export class CommodityAndUnitsRec {

    commodity: string;
    units: string;

    constructor(commodity: string, units: string) {
        this.commodity = commodity;
        this.units = units;

    }
}

export interface INodeCommodities {
    inputCommodities: CommodityAndUnitsRec[];
    outputCommodities: CommodityAndUnitsRec[];

}


// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.commodity-and-units-rec.ts